// extracted by mini-css-extract-plugin
export default {"BackHeader":"BackHeader_BackHeader__fLg11","BackHeader_btn":"BackHeader_BackHeader_btn__7HAkz","btnAnim":"BackHeader_btnAnim__7o8-f","btnAnim2":"BackHeader_btnAnim2__AqP+0"};